import { PhaseForm } from "./_PhaseForm";

export function PhaseCreate() {
  return <PhaseForm action="create" />;
}

export default PhaseCreate;
